import { useCallback, useSyncExternalStore } from 'react';

import { resources, translate, type Locale, type TranslationParams } from './resources';
import { detectLocale, storeLocale } from './storage';

export interface I18nValue {
  readonly locale: Locale;
  readonly setLocale: (locale: Locale) => boolean;
  readonly t: (key: string, params?: TranslationParams) => string;
}

const listeners = new Set<() => void>();
let activeLocale: Locale | null = null;

export function setLocale(locale: Locale): boolean {
  if (activeLocale === locale) {
    return storeLocale(locale);
  }
  activeLocale = locale;
  const stored = storeLocale(locale);
  for (const listener of listeners) {
    listener();
  }
  return stored;
}

export function getLocale(): Locale {
  activeLocale ??= detectLocale();
  return activeLocale;
}

export function useI18n(): I18nValue {
  const locale = useSyncExternalStore(subscribe, getLocale, serverLocale);
  const t = useCallback(
    (key: string, params?: TranslationParams): string => translate(locale, key, params),
    [locale],
  );
  return { locale, setLocale, t };
}

export { resources };

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function serverLocale(): Locale {
  return 'en';
}
